import startCase from 'lodash/startCase';

import { IntegrationType } from '../useIntegrations/integrations';

type GetTooltipContentProps = {
  cardType?: string;
  integrationType?: IntegrationType;
};

/** A function that returns the tooltip content for an integration. */
export const getTooltipContent = ({
  cardType,
  integrationType,
}: GetTooltipContentProps): string | null => {
  if (!integrationType || !cardType) {
    return null;
  }

  if (cardType === 'custom') {
    return startCase(integrationType);
  }

  return `${startCase(cardType)} ${startCase(integrationType)}`;
};
